export const GetGraphData = async (accessToken?: string) => {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);

  const options = {
    method: "GET",
    headers,
  };

  return fetch(
    `https://graph.microsoft.com/v1.0/me?$select=mail,jobTitle,department,onPremisesExtensionAttributes,displayName`,
    options
  )
    .then((res) => res.json())
    .catch((error) => console.log(error));
};

const getProfileImage = async (accessToken) => {
  // console.log(accessToken)
  const apiUrl = "https://graph.microsoft.com/v1.0/me/photo/$value"; // Example endpoint for profile photo

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  const response = await fetch(apiUrl, {
    method: "GET",
    headers,
  });

  // if (!response.ok) {
  //   throw new Error("Failed to fetch the profile image.");
  // }
  
  const imageBlob = await response.blob(); // Get the image data as a Blob
  return imageBlob;
};

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      resolve(reader.result);
    });
    // eslint-disable-next-line unicorn/prefer-add-event-listener
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(blob);
  });

export const fetchAndDisplayProfileImage = async (accessToken) => {
  try {
    const imageBlob = await getProfileImage(accessToken);
    const base64Image = await blobToBase64(imageBlob);

    // Now you can use 'base64Image' in your component, e.g., as an image source:
    // console.log("base64Image", base64Image);
    return base64Image;
  } catch (error) {
    console.error("Error fetching or converting the profile image:", error);
    throw error;
  }
};
